import React, { useState } from 'react';
import { Button } from '../../ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';
import { AttachmentGallery } from './AttachmentGallery';
import { OriginBadge } from './OriginBadge';
import { MomentAiPanel } from './MomentAiPanel';
import { FollowUpModal } from '../followups/FollowUpModal';
import { formatMomentDate, formatMomentTime } from '../../../utils/momentDates';

export const MomentDetailModal = ({ moment, onEdit, onDelete, onClose }) => {
  const [followUpOpen, setFollowUpOpen] = useState(false);
  const [followUpMsg, setFollowUpMsg] = useState('');

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-slate-900/40 p-0 sm:p-4" onClick={onClose}>
      <div
        className="bg-white w-full sm:max-w-xl rounded-t-3xl sm:rounded-3xl p-6 space-y-4 max-h-[92vh] overflow-y-auto shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-4">
          <div className="min-w-0">
            <p className="text-xs font-bold uppercase tracking-wider text-slate-400">
              {formatMomentDate(moment.occurred_at)} · {formatMomentTime(moment.occurred_at)}
            </p>
            <h2 className="mt-1 text-2xl font-extrabold text-slate-900 tracking-tight break-words">
              {moment.title || 'Untitled moment'}
            </h2>
            <OriginBadge moment={moment} className="mt-2" />
          </div>
          <button onClick={onClose} className="p-2 rounded-xl text-slate-400 hover:bg-slate-100" aria-label="Close">
            <SafeIcon icon={FiIcons.FiX} />
          </button>
        </div>
        {moment.body && (
          <p className="text-[15px] leading-relaxed text-slate-700 whitespace-pre-wrap break-words">{moment.body}</p>
        )}
        <MomentAiPanel moment={moment} />
        <AttachmentGallery attachments={moment.attachments || []} />
        {moment.people?.length > 0 && (
          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-2">With</p>
            <div className="flex flex-wrap gap-2">
              {moment.people.map((p) => (
                <span key={p.id} className="rounded-full bg-slate-100 px-3 py-1 text-sm font-medium text-slate-700">
                  {p.full_name || 'Contact'}{p.company ? ` · ${p.company}` : ''}
                </span>
              ))}
            </div>
          </div>
        )}
        {followUpMsg && <p className="text-sm font-medium text-emerald-700">{followUpMsg}</p>}
        <div className="flex flex-wrap justify-end gap-3 pt-2">
          <Button variant="secondary" onClick={() => setFollowUpOpen(true)}>
            <SafeIcon icon={FiIcons.FiCalendar} className="mr-2" /> Follow up
          </Button>
          <Button variant="secondary" onClick={() => onDelete(moment)}>
            <SafeIcon icon={FiIcons.FiTrash2} className="mr-2" /> Delete
          </Button>
          <Button onClick={() => onEdit(moment)}>
            <SafeIcon icon={FiIcons.FiEdit2} className="mr-2" /> Edit
          </Button>
        </div>
      </div>
      {followUpOpen && (
        <div onClick={(e) => e.stopPropagation()}>
          <FollowUpModal
            people={moment.people?.length > 0 ? moment.people : undefined}
            momentId={moment.id}
            momentTitle={moment.title || 'Untitled moment'}
            onClose={() => setFollowUpOpen(false)}
            onSaved={(row, text) => {
              setFollowUpOpen(false);
              setFollowUpMsg(text);
              setTimeout(() => setFollowUpMsg(''), 3000);
            }}
          />
        </div>
      )}
    </div>
  );
};